import { render, staticRenderFns } from "./VarietyDetail.vue?vue&type=template&id=c01bc2c6&"
import script from "./VarietyDetail.vue?vue&type=script&lang=js&"
export * from "./VarietyDetail.vue?vue&type=script&lang=js&"
import style0 from "./VarietyDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/Coding/farmerspace/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VImg,VLayout,VProgressCircular})
